import { useEffect, useState } from "react";

export const LS_RECENT_WORKSPACE_IDS = "piq_recent_workspace_ids";
const MAX_STORED_RECENT_WORKSPACES = 20;

const readStoredIds = (): string[] => {
  try {
    const parsed: unknown = JSON.parse(
      localStorage.getItem(LS_RECENT_WORKSPACE_IDS) ?? "[]",
    );
    return Array.isArray(parsed)
      ? parsed.filter((id): id is string => typeof id === "string")
      : [];
  } catch {
    return [];
  }
};

/**
 * Tracks workspaces the user has opened, most recent first, persisted in
 * localStorage. Pass the currently open workspace id (or null).
 */
export const useRecentWorkspaceIds = (
  openedWorkspaceId: string | null,
): string[] => {
  const [recentWorkspaceIds, setRecentWorkspaceIds] =
    useState<string[]>(readStoredIds);

  useEffect(() => {
    if (!openedWorkspaceId) return;
    setRecentWorkspaceIds((previousIds) =>
      previousIds[0] === openedWorkspaceId
        ? previousIds
        : [
            openedWorkspaceId,
            ...previousIds.filter((id) => id !== openedWorkspaceId),
          ].slice(0, MAX_STORED_RECENT_WORKSPACES),
    );
  }, [openedWorkspaceId]);

  useEffect(() => {
    localStorage.setItem(
      LS_RECENT_WORKSPACE_IDS,
      JSON.stringify(recentWorkspaceIds),
    );
  }, [recentWorkspaceIds]);

  return recentWorkspaceIds;
};
